import UESupport from '../../../components/common/UESupport';
import AccordionForm from './AccordionForm/AccordionForm';
import FarmSelect from '../../../components/FarmSelect/FarmSelect';
import { AccordionFormContextProvider } from '../../../store/accordion-form-context';

export default function LoansScreenContent() {
  const reloadWindow = () => window.location.reload();
  return (
    <>
      {/* <FarmSelect onChange={reloadWindow} /> */}
      <AccordionFormContextProvider>
        <AccordionForm />
      </AccordionFormContextProvider>
      <UESupport />
    </>
  );
}
